import { render, staticRenderFns } from "./PropertyTable.global.vue?vue&type=template&id=6253c9f5&lang=pug&"
import script from "./PropertyTable.global.vue?vue&type=script&lang=ts&"
export * from "./PropertyTable.global.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports